/**
 * @file SessionKindBadge.tsx
 * @brief Visual badge mapping `sessions.session_kind` → variant.
 *
 * @details
 * `realtime` sessions are highlighted with the `info` palette to match
 * the live-pill look used on the mobile app's Sessions screen.
 * `standard` sessions get a muted look so the badge column stays calm
 * for the dominant case.
 *
 * @author DES
 * @date 26-05-2026
 */

import { Radio, Zap } from "lucide-react";
import { Badge } from "@/components/ui/Badge";
import type { SessionKind } from "../schemas";

export function SessionKindBadge({ kind }: { kind: SessionKind }) {
  if (kind === "realtime") {
    return (
      <Badge variant="info" className="gap-1">
        <Zap className="h-3 w-3" />
        Realtime
      </Badge>
    );
  }
  return (
    <Badge variant="muted" className="gap-1">
      <Radio className="h-3 w-3" />
      Standard
    </Badge>
  );
}
